import axios from 'axios';
import moment from 'moment';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
const baseurl = 'pelunasanpinjaman';
export default {
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post(baseurl, obj);
                resolve(data.pelunasankey);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    saveFollowupRejected(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post(`${baseurl}/followup-rejected`, obj);
                resolve(data.pelunasankey);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    expired(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post(`${baseurl}/expired-memo`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'CustName','CustCode', 'collectability', 'collector_id', 'model_pinjaman', 
                'tglsurat1', 'tglsurat2','tgl1', 'tgl2','rrd_dt1', 'rrd_dt2','nomor','status_memo', 
                'agreement', 'contract_status', 'wo_status','nosurat','pinjamankey','posting'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    listreadytosettlement(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'CustName','CustCode', 'collectability', 'collector_id', 'model_pinjaman', 
                'tglsurat1', 'tglsurat2','tgl1', 'tgl2','rrd_dt1', 'rrd_dt2','nomor','status_memo', 
                'agreement', 'contract_status', 'wo_status','nosurat','pinjamankey','posting'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/ready-to-settlement${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    exportxls(obj = {},) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer', 'collectability', 'collector_id', 'model_pinjaman', 
                    'tgl1', 'tgl2','tglsurat1', 'tglsurat2','status_memo'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxls/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'pelunasan.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxlsPayment(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'CustName', 'CustCode', 'collectability', 'collector_id', 'model_pinjaman', 'nomor', 
                'status_memo', 'agreement', 'contract_status', 'wo_status','nosurat','posting','pinjamankey', 'tglsurat1', 'tglsurat2', 'tgl1', 'tgl2', 'rrd_dt1', 'rrd_dt2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxlsPayment/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `payment_pelunasan_list_${moment().format('YYYYMMDD')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxlsWO(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer', 'collectability', 'collector_id', 'model_pinjaman', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxlsWO/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'settlement_memo_pelunasan.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detail(pelunasankey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/detail/${pelunasankey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    delete(pelunasankey) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.delete(`${baseurl}/delete/${pelunasankey}`);
                resolve(data.pelunasankey);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    printPDFMemoPelunasan(pelunasankey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/printPDFMemoPelunasan/${pelunasankey}`);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    printPDFFileNameMemoPelunasan(pelunasankey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/printPDFMemoPelunasan/${pelunasankey}`);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf-filename/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    printPDFSPP(pelunasankey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/printPDFSPP/${pelunasankey}`);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    postingsettlement(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/posting-settlement`, obj);
                resolve(true);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    postingbulksettlement(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/posting-bulk-settlement`, obj);
                resolve(true);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    settlement(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post(`${baseurl}/settlement`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    approval(formData) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post(`${baseurl}/send2wf`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approvalRevisi(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post(`${baseurl}/approval-revisi`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    approvalUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`${baseurl}/send2wfCancel/${obj.pelunasankey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    spp(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post(`${baseurl}/spp`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    
    getworkflow() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/getworkflow`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    getMemoPinjaman(pinjamankey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/get-memo-pinjaman/${pinjamankey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    ceknomorMemo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['nosurat'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`${baseurl}/ceknomorMemo/${str}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    saveblacklist(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post(`${baseurl}/save-blacklist`,obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    blacklist(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir','CustName','CustCode','no_kontrak','no_agreement','isblocked'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/blacklist${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    detailblacklist(tableKey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/detail-blacklist/${tableKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    detailblacklistbypinjamankey(pinjamankey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/detail-blacklist-bypinjamankey/${pinjamankey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    getworkflowblacklist() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/getworkflow-blacklist`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    send2wfopenblacklist(formData) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post(`${baseurl}/send2wfopenblacklist`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    send2wfCancelopenblacklist(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`${baseurl}/send2wfCancelopenblacklist/${obj.reqsend2wf}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    memocollectionlist(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'CustName','CustCode', 'collectability', 'collector_id', 'model_pinjaman', 
                'tglsurat1', 'tglsurat2','tgl1', 'tgl2','rrd_dt1', 'rrd_dt2','nomor','status_memo', 
                'agreement', 'contract_status', 'wo_status','nosurat','pinjamankey','posting'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/memo-pelunasan-collection${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    memocollectionexportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer', 'collectability', 'collector_id', 'model_pinjaman', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/memocollectionexportxls/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `memopelunasancollection_${moment().format('YYYYMMDD')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    paymentmemopelunasan(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'CustName','CustCode', 'collectability', 'collector_id', 'model_pinjaman', 
                'tglsurat1', 'tglsurat2','tgl1', 'tgl2','rrd_dt1', 'rrd_dt2','nomor','status_memo', 
                'agreement', 'contract_status', 'wo_status','nosurat','pinjamankey','posting'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/paymentmemopelunasan${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
};